"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LootTable_1 = __importDefault(require("../../structures/LootTable"));
exports.default = new LootTable_1.default()
    .add('Grimy guam leaf', 1, 32)
    .add('Grimy marrentill', 1, 24)
    .add('Grimy tarromin', 1, 18)
    .add('Grimy harralander', 1, 14)
    .add('Grimy ranarr weed', 1, 11)
    .add('Grimy irit leaf', 1, 8)
    .add('Grimy avantoe', 1, 6)
    .add('Grimy kwuarm', 1, 5)
    .add('Grimy cadantine', 1, 4)
    .add('Grimy lantadyme', 1, 3)
    .add('Grimy dwarf weed', 1, 3);
//# sourceMappingURL=HerbDropTable.js.map